<template>
    <div>
        <div v-if="gameType=='fruitmachine'" @click="next" class="help">
            <div class="item item1" v-if="itemNr==0">
                <img class="arrow rotate-0" src="../assets/images/arrow.svg" alt>
                <h4>Hier zie je het aantal appels dat je nog te goed hebt.</h4>
            </div>
            <div class="item item2" v-if="itemNr==1">
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
                <h4>Vul de koker tot aan hier, voordat al je appels op zijn, om het level te halen!</h4>
            </div>
            <div class="item item3" v-if="itemNr==2">
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
                <h4>Beantwoord de vraag die hier verschijnt...</h4>
            </div>
            <div class="item item4" v-if="itemNr==3">
                <h4>...door 1 van deze antwoorden te kiezen.</h4>
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
            </div>
            <div class="item item5" v-if="itemNr==4">
                <h4>Zijn al je appels op? Dan verschijnt hier je highscore!</h4>
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
            </div>
            <div class="item item6" v-if="itemNr==5">
                <img class="arrow rotate-0" src="../assets/images/arrow.svg" alt>
                <h4>Hier kies je een level, of start je opnieuw.</h4>
            </div>
            <div class="item item7" v-if="itemNr==6">
                <h1>Veel succes!</h1>
            </div>
            <div class="footer">
                <img class="logo tsc" src="../assets/images/tsclogo.jpg" alt>
                <h5 class="logo">Powered by:</h5>
                <img class="logo cbl" src="../assets/images/cbllogo.jpg" alt>
            </div>
        </div>

        <div v-if="gameType=='training'" @click="next" class="help">
            <div class="item item1T" v-if="itemNr==0">
                <img class="arrow rotate-0" src="../assets/images/arrow.svg" alt>
                <h4>Hier zie je het aantal appels dat je nog te goed hebt.</h4>
            </div>
            <div class="item item2T" v-if="itemNr==1">
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
                <h4>Vul de koker tot aan hier, voordat al je appels op zijn, om het level te halen!</h4>
            </div>
            <div class="item item3T" v-if="itemNr==2">
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
                <h4>Beantwoord de vraag die hier verschijnt...</h4>
            </div>
            <div class="item item4T" v-if="itemNr==3">
                <h4>...door 1 van deze antwoorden te kiezen.</h4>
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
            </div>
            <div class="item item5T" v-if="itemNr==4">
                <h4>Zijn al je appels op? Dan verschijnt hier je highscore!</h4>
                <img class="arrow rotate-45" src="../assets/images/arrow.svg" alt>
            </div>
            <div class="item item6T" v-if="itemNr==5">
                <img class="arrow rotate-0" src="../assets/images/arrow.svg" alt>
                <h4>Hier kies je een level, of start je opnieuw.</h4>
            </div>
            <div class="item item7T" v-if="itemNr==6">
                <h1>Veel succes!</h1>
            </div>
            <div class="footer">
                <img class="logo tsc" src="../assets/images/tsclogo.jpg" alt>
                <h5 class="logo">Powered by:</h5>
                <img class="logo cbl" src="../assets/images/cbllogo.jpg" alt>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from "../main";

export default {
    name: "Help",
    data() {
        return {
            itemNr: 0
        };
    },
    props: {
        gameType:{
            type: String,
            required: true
        }
    },
    methods: {
        next() {
            this.itemNr++;
            if (this.itemNr > 6) {
                this.itemNr = 0;
                this.close();
            }
        },
        close() {
            eventBus.$emit("toggleHelp");
        }
    }
};
</script>

<style scoped>
.footer {
    text-align: left;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6%;
    background: #fff;
    padding: 1%;
    box-sizing: border-box;
}
.logo {
    height: 100%;
    width: auto;
    float: right;
    margin-left: 2.5%;
    margin-right: 2.5%;
}
h3 {
    display: inline;
    margin-left: 5%;
}

h4 {
    color: #000;
    float: right;
}
.item {
    position: absolute;
    width: 100%;
}
.item1 {
    top: 11%;
    left: 15%;
}
.item1T {
    top: 11%;
    left: 15%;
}
.item2 {
    top: 38%;
    left: 14%;
}
.item2T {
    top: 27%;
    left: 14%;
}
.item3 {
    top: 30%;
    left: 50%;
}
.item3T {
    top: 15%;
    left: 50%;
}
.item4 {
    top: 60%;
    left: 30%;
}
.item4T {
    top: 80%;
    left: 20%;
}
.item4 img {
    transform: rotate(180deg);
}
.item4T img {
    transform: rotate(180deg);
}

.item5 {
    top: 15%;
    left: 40%;
}
.item5 img {
    transform: scaleX(-1);
}

.item5T {
    top: 15%;
    left: 40%;
}
.item5T img {
    transform: scaleX(-1);
}

.item6 {
    top: 4%;
    left: 40%;
}
.item6T {
    top: 4%;
    left: 45%;
}
.item7 {
    top: 30%;
    left: 30%;
}
.item7T {
    top: 30%;
    left: 30%;
}
h1 {
    display: inline-block;
    float: left;
    color: #fff;
    text-shadow: 2px 2px #000;
}
h4 {
    display: inline-block;
    width: 30%;
    float: left;
    color: #fff;
    text-shadow: 2px 2px #000;
}
.arrow {
    display: inline-block;
    float: left;
    width: 15%;
    margin-right: 2%;
}
.help {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
}
.help:hover {
    cursor: pointer;
}
.rotate-45 {
    transform: rotate(-45deg);
}
.rotate-0 {
    transform: rotate(-30deg);
}
.cbl {
    float: left;
}
.tsc {
    float: right;
}
</style>
